export const miningHints = {
  mining: 'This page is dedicated to comprihensive summary needed for mining decisions.',
  miners: 'Participant in a Proof of Work blockchain network who contributes computing power to validate and process transactions..',
  peers: 'Nodes that are connected to each other in a decentralized network',
  pools: 'Group of cryptocurrency miners who combine their computational resources to mine blocks together and share the rewards.',
  hashrate: 'Current computational power of network.',
  hashrateTrend: 'Computational power of network over time.',
  difficulty: 'Dynamic measure that determines how hard it is to find a valid hash that meets the network\'s requirements when mining a new block. It\'s an automatically adjusting parameter that helps maintain a consistent block time despite changes in total network hashrate.',
  blockTime: 'Average time for keyblock creation.',
  maxTPS: 'Bandwidth of transactions per seconds over network.',
  reward: 'Latest amount that was paid to the miner who added the keyblock to the blockchain, as an incentive for their participation and contribution to the network.',
  blocksMined: 'Count of blocks mined from the creation of the blockchain.',
  miningPoolName: 'Name of the mining pool.',
  miningPoolUrl: 'Link to mining pool external page that provides detailed pool description.',
  minerAccount: 'Address of the miner account.',
  minerTotalReward: 'Reward collected by the miner from the creation of the blockchain.',
  miningPoolsChart: 'Distribution of blocks mined by different pols in last 24 hours',
}
